var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c("div", { staticClass: "cancel-scenario-modal-overlay" }, [
        _c(
          "div",
          {
            staticClass: "cancel-scenario-modal",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("div", { staticClass: "cancel-scenario-modal-content" }, [
              !_vm.orderSelfServiceClicked
                ? _c("h3", [_vm._v(_vm._s(_vm.$t("cancelscenario.label")))])
                : _c("h3", [
                    _vm._v(_vm._s(_vm.$t("cancelscenario.labelSelfService"))),
                  ]),
              _vm._v(" "),
              !_vm.orderSelfServiceClicked
                ? _c("p", [_vm._v(_vm._s(_vm.$t("cancelscenario.text")))])
                : _c("p", [
                    _vm._v(_vm._s(_vm.$t("cancelscenario.textSelfService"))),
                  ]),
              _vm._v(" "),
              _vm.orderSelfServiceClicked
                ? _c(
                    "svg",
                    {
                      attrs: {
                        viewBox: "0 0 24 24",
                        width: "64",
                        height: "64",
                        "aria-hidden": "true",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: { cx: "12", cy: "12", r: "10", fill: "#22c55e" },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M8.5 12.5l2.2 2.2 4.8-6",
                          fill: "none",
                          stroke: "#fff",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.orderSelfServiceClicked
                ? _c("div", { staticClass: "cancel-scenario-modal-buttons" }, [
                    _c(
                      "button",
                      {
                        staticClass: "cancel-scenario-modal-button primary",
                        attrs: { disabled: _vm.loading },
                        on: { click: _vm.handleOrderService },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("cancelscenario.buttonOrderService"))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "cancel-scenario-modal-button secondary",
                        attrs: { disabled: _vm.loading },
                        on: { click: _vm.handleSelfService },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("cancelscenario.buttonSelfService"))
                          ),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }